import React,{useEffect, useState, useRef} from "react";
import { useModel ,useRoute, useParams,useCCTM} from "bcms-react";

import "./styles.css";

import BottomNavView from "components/shared/views/BottomNavView";


/**
 * @function BottomNavWrapper 
 * @returns {React.Component}
 * @exported true
 * @description This is the iframe wrapper that will pull in ABI22 and show the BottomNavView component.
 */
export default function BottomNavWrapper(props) {
  const [src, setSrc]  = useState({route:props.page,key:Date.now()});
  const { b,c, branding } = useModel();
  const {footer} = useParams();
  const ref = useRef();
  const course = branding.options.abi22_courseid_mabi23;
 const xml = useCCTM();

  let nav = useRoute();
  const [ hideNav, setHideNav ] = useState(props.hideNav ?? footer === "noFooter" ? true : false); 
  const origin =  window.location.origin.indexOf("localhost") !== -1 ?`http://${window.location.hostname}:${parseInt(window.location.port)+1}` :window.location.origin+`${window.location.pathname.replace("mabi23","abi22")}?b=${ b }&c=${ course }`;
  const iframeSrc = `${ origin}/#/${props.page}`;
  
  const refreshFrame = (route)=>{

  
   nav(`/content/${route}`)
      ref.current.contentWindow.postMessage({message:"force-global-route",detail: {
      route: `/${route}`
    }   },"*");
    
 
    }   

document.loadFrame = function() {

if(document.demoLoaded === undefined) {
  document.demoLoaded = iframeSrc;
  window.parent.document.loadFrame();
}

  ref.current.setAttribute("abi22","true");
} 


window.addEventListener("message", evt => {
  if(evt.data.message === "force-global-route"){
   const { route, state } = evt.data.detail;
   let newSrc ={route:route,key:Date.now()}; 
  
      
    nav(route)
  
 
  }
});

useEffect(() => {
  // START: Set event listeners then remove them on component unmount
  // to prevent multiple listeners from being set.
  // Issue occurs with "ad" click events being called mulitiple times in the child abi22 iframe.
  const abi22IframeDidLoad = evt => {
    var mabiStyles = document.getElementsByTagName("style");
   var mabi23BrandingStyles = Object.keys(mabiStyles).reduce(function(res,index){
          var elem = mabiStyles[index];
          if(res === null){
            return elem.innerHTML.indexOf("Templated Strings CSS File") !== -1 ? elem : res;
          }else{
            return res;
          }

        },null)  
    if(evt.data.message === "abi22-iframe-did-load") {
      const serializer = new XMLSerializer();
      
      const message = { 
        message: {
          mabi23Branding: { ...branding },
          "mabi23BrandingStyles":mabi23BrandingStyles.innerHTML,

          mabiMenu:serializer.serializeToString(xml)
          
        } 
      };
      ref.current.contentWindow.postMessage(message, "*");
    }
  };
  // Function that listens to a message from CH21 integrated in ABI22. 
  // That CH21 instance exists in an iframe in component "ABI22PageIframeView"
  // which is different than the ABI22 iframe returned below.
  const closeABI22MobileMenu = evt => {
    if(evt.data.message === "closeABI22MobileMenu") {
        ref.current.contentWindow.postMessage({ message: "closeABI22MobileMenu" }, "*")
    }
  }

  // Function that listens to a message from abi22 to hide/show the bottom nav.
  // It is needed in the "Deposits" workflow where the camera view needs
  // to take up the entire screen view.
  const hideMABI23BottomNav = evt => {
    const message = evt.data.message;

    if(message) {
      if(message.hideMABI23BottomNav) {
        setHideNav(message.hideMABI23BottomNav === "true");
      }
    }
  }
    
  window.addEventListener("message", abi22IframeDidLoad);
  window.addEventListener("message", closeABI22MobileMenu);
  window.addEventListener("message", hideMABI23BottomNav);

  // END: Set event listeners then remove them on component unmount
  // to prevent multiple listeners from being set.
  // Issue occurs with "ad" click events being called mulitiple times in the child abi22 iframe.

  return () => {
    window.removeEventListener("message", abi22IframeDidLoad);
    window.removeEventListener("message", closeABI22MobileMenu);
    window.removeEventListener("message", hideMABI23BottomNav);
  };
}, []);

  return (
    <div className={`bottom-nav-wrapper ${hideNav ?"no-nav":""}`}>
      <iframe key ={src.key} ref={ref} title="Bottom Nav Wrapper" src={ iframeSrc } />
      {!hideNav && <BottomNavView  setSrc = {refreshFrame}/>}
   </div>
  );
}